import { exportExcel } from "../service/exportService";

export const useExportarExcel = () => {
  const execute = (idCliente, tipoCliente, filtros) => {
    exportExcel(idCliente, tipoCliente, filtros);
  };

  return {
    execute,
  };
};
